import { useAuth } from '../../contexts/AuthContext';

interface HeaderProps {
  title: string;
}

export function Header({ title }: HeaderProps) {
  const { tenant } = useAuth();

  return (
    <header className="flex justify-between items-center mb-6 p-4 bg-dark-card rounded-xl border border-dark-border">
      <h1 className="text-xl font-semibold text-primary-500">
        💰 {title}
      </h1>
      <div className="flex items-center gap-3">
        <span className="w-2.5 h-2.5 rounded-full bg-primary-500 animate-pulse-dot" />
        <span className="text-sm text-gray-400">
          {tenant?.name || 'Conectando...'}
        </span>
      </div>
    </header>
  );
}
